import { RouterSelectors } from "@app/root-store/selectors";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
    CustomerLocationState,
    CustomerLocationUsersState,
    initialCustomerLocationUsersState,
    initialState,
} from "../customer-location.state";

const selectState = createFeatureSelector<CustomerLocationState>("customer-location");

export const getCustomerLocationsState = createSelector(
    selectState,
    (state: CustomerLocationState = initialState) => state.claresystems || initialState.claresystems
);

export const getCurrentLocation = createSelector(
    selectState,
    RouterSelectors.selectUrlParam("uuid"),
    (state: CustomerLocationState = initialState, uuid: string = "") => {
        if (!!uuid && state?.claresystems?.result) {
            return state.claresystems.result.find(location => location.uuid === uuid);
        }

        return null;
    }
);

export const getLocationUsersState = createSelector(
    selectState,
    (state: CustomerLocationState = initialState) =>
        (uuid: string): CustomerLocationUsersState =>
            state.users[uuid] || initialCustomerLocationUsersState
);

export const getCustomerRoleId = createSelector(selectState, (state: CustomerLocationState = initialState) => state.customerRoleId);

export const getLocationDataState = createSelector(selectState, (state: CustomerLocationState = initialState) => state.locationData);
